module.exports = __webpack_public_path__ + "static/media/pixel mall shot 01.523b7535.webp";